export default function AboutHeader() {
  return (
    <section className="px-4 md:px-10 pt-12 md:pt-16 pb-10 md:pb-14 bg-background-100 border-b border-background-200">
      <div className="max-w-6xl mx-auto">
        <p className="text-secondary-500 text-xs uppercase tracking-[0.25em] mb-4 font-semibold">Sobre nosotros</p>
        <h1 className="font-heading text-4xl md:text-6xl font-semibold text-foreground-950 leading-tight max-w-3xl">
          Bufete Ramos Santos, abogados en Heredia
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mt-5 max-w-2xl leading-relaxed text-left md:text-justify hyphens-none">
          Más de dos décadas de ejercicio profesional en derecho de familia, penal, civil y notarial, con atención personal y directa del Máster León Felipe Ramos Santos.
        </p>
      </div>
    </section>
  );
}